// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__g81dv","topBottomGutter":"Layout_topBottomGutter__1Qpf2"};